import { routes } from '@pmai/contracts';

/** Views computed from projects and their timesheets — refreshed after a project or sheet changes. */
export const PROJECT_DERIVED_VIEWS = [routes.turnover.get, routes.overview.get, routes.overview.roadmap];
